import 'arrayq';
import { PureConnect, React } from '../../react';
import { Modal } from '../modal/index';
import { INote} from '../../types';
import { notesEditor } from '../notes/resource';
import cx from './style.less';
import authSelectors from '../../auth/selectors';
import notesSelector from '../notes/selectors';
import questionSelector from './selectors';
import selectorsParticipantPopup from '../noteParticipantSelectPopup/selectors';
import selectorsCategoryPopup from '../categorySelectPopup/selectors';
import { participantsResource } from '../../participant/resource';
import { QuestionSaveArea as QuestionSaveArea, ModalQuestionEditLayout } from '../question/questionEditArea';
import UPDATE_BUTTON_NO from '../../focuslock/actions/UPDATE_BUTTON_NO';
import FocusLockFocusGuard from '../../focuslock/focuslockext';
import windowSelectors from '../../window/selectors';

import LinkQuestionEditModal, { CommitLinkQuestionModal, LinksOfQuestionModal, LinksOfQuestionModalCancel } from '../question/questionLinkEditor';

export const QuestionEditModal = PureConnect(`QuestionEditModal`)(
    (state) => ({
        creating: notesEditor.selectors.creating(state),
        updating: notesEditor.selectors.updating(state),
        item: notesEditor.selectors.item(state),
        user: authSelectors.user(state),
        userparticipant: participantsResource.selectors.items(state).qFirst((itm) => itm.isUser),
        origin: state.notemenu.origin,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),    
        screenSmall: windowSelectors.small(state),   
        isminimized: notesSelector.isminimized(state),
        flyoverVisible: state.flyover.visible,
        ismaximized: questionSelector.ismaximized(state),
    }),
    (dispatch) => ({
        cancel: () => dispatch(notesEditor.actions.RESET({ })),
        cancelCreating: () => {            
            dispatch(notesEditor.actions.CREATE_CANCEL({ }));},
        cancelUpdating: () => {
            dispatch(notesEditor.actions.UPDATE_CANCEL({ }));},
        updateButtonFocus: (buttonNr: number, origin: number, itm: INote) => {
            dispatch(UPDATE_BUTTON_NO({buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem:itm})); 
        },
    }),
    ({ flyoverVisible, creating, updating, item, isminimized, ismaximized, origin, screenSmall, cancelCreating, cancelUpdating, participantPopupVisible, categoryPopupVisible }) => {
        const isquestion = item && !!item.isquestion;

        return (
           <Modal 
                onEscKeyDown={!participantPopupVisible && !categoryPopupVisible? 
                      (creating ? ()=> cancelCreating() : ()=> cancelUpdating()): () => {}} 
                  visible={!flyoverVisible && (creating || updating) && isquestion} 
                  type={screenSmall ? 'smallscreen': ismaximized? 'maximized': 'center2nd' }
                  backdrop={true}            
                  minimized={isminimized}      
                  header={<div className={cx('app')}></div>}
                >                   
                <div className={cx((!creating && !updating)|| isminimized ? 'wcag-invisible' : '', 'fields-container')}  
                    aria-hidden={!(creating || updating)|| isminimized} 
                    aria-labelledby= "Maak een vraag aan">
                    <FocusLockFocusGuard 
                        disabled={!(creating || updating)}>   
                        <LinkQuestionEditModal />
                        <CommitLinkQuestionModal />
                        <LinksOfQuestionModal />
                        <LinksOfQuestionModalCancel />                      
                        <ModalQuestionEditLayout />
                        <QuestionSaveArea />
                    </FocusLockFocusGuard>
                </div>         
            </Modal> 
        );
});



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/questionEditModal.tsx